import { FC } from 'react';

import PercentageMonitor from '@shared/uikit/percentage-monitor';

interface IValueWithPercentageMonitorProps {
  value: string | number;
  percentage: string | number;
  mode: 'up' | 'down';
}

const ValueWithPercentageMonitor: FC<IValueWithPercentageMonitorProps> = ({
  value,
  percentage,
  mode,
}) => {
  return (
    <div className="flex">
      <span className="mr-[10px]">{value}</span>
      {percentage !== 0 ? <PercentageMonitor value={+percentage} mode={mode} /> : null}
    </div>
  );
};

export default ValueWithPercentageMonitor;
